import React from "react";

const ClockIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15.5 12H12V7m-9 5a9 9 0 1 0 18.001 0A9 9 0 0 0 3 12"
    ></path>
  </svg>
);

export default ClockIcon;
